export const faqs = [
  {
    question: "在爆料51匿名投稿，真的不会被查到身份吗？",
    answer:
      "投稿不需要注册账号，也不要求填写姓名、手机号或单位。我们只保留阅读与核实所必需的最少信息，会对正文中的身份线索做脱敏处理。不过匿名并不等于绝对安全，建议你同时参考爆料指南中的自我保护建议，尽量使用不关联个人身份的设备和网络环境。",
  },
  {
    question: "匿名投稿需要提供证据吗？需要提供到什么程度？",
    answer:
      "证据不是硬性门槛，但能显著提高信息被采纳的可能。你可以提交文字描述、时间线、公开可查的记录等。请勿提交含有你个人身份信息的原始文件，也不要在材料中保留可反查来源的元数据。",
  },
  {
    question: "提交之后，怎么知道有没有被处理？",
    answer:
      "如果愿意，你可以在投稿时填写一个只属于你的回执代号，例如一串自定义字符。我们会通过该代号进行匿名回执，不会反过来索要你的真实身份。未填写代号的投稿，我们同样会处理，只是无法向你反馈进展。",
  },
  {
    question: "你们会把我的原话原封不动发出来吗？",
    answer:
      "不会。所有内容都会先经过核实、脱敏与改写，再决定以何种形式使用。涉及具体个人、可定位的细节会被模糊化，避免任何一方因为你的投稿而受到不必要的困扰。",
  },
  {
    question: "哪些内容不在受理范围内？",
    answer:
      "纯情绪表达而无具体事实指向的内容、涉及他人隐私却与公共利益无关的内容、无法核实的传闻，以及明显带有商业诋毁或恶意竞争目的的内容，都不在受理范围内。我们更看重事实本身，而不是立场。",
  },
  {
    question: "投稿内容会被长期保存吗？",
    answer:
      "我们遵循最小留存原则。信息只在处理与核实所需的时间内保留，超出必要周期后会按流程清理。已经完成处理的投稿，不会无限期保存原文。",
  },
  {
    question: "能否在投稿中直接点名某个具体的人？",
    answer:
      "可以描述事实经过，但请尽量避免直接指向无关的私人个体。如果确实与公共利益相关，请尽量提供可核实的背景与时间线，我们会自行判断如何处理相关指称。",
  },
  {
    question: "如果我担心投稿后被追溯，有什么更稳妥的方式？",
    answer:
      "建议使用与日常工作、生活账号完全分离的设备与网络环境，避免在投稿正文中出现只有你才知道的内部细节组合，也不要上传带有拍摄信息的原始文件。投稿前可先阅读爆料指南中的安全清单。",
  },
];